import { render, staticRenderFns } from "./CoverLimitReachedNotice.vue?vue&type=template&id=b6ef3220&scoped=true"
import script from "./CoverLimitReachedNotice.vue?vue&type=script&lang=js"
export * from "./CoverLimitReachedNotice.vue?vue&type=script&lang=js"
import style0 from "./CoverLimitReachedNotice.vue?vue&type=style&index=0&id=b6ef3220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ef3220",
  null
  
)

export default component.exports